import ReactDOM from 'react-dom';
import React from 'react';
import {StyleSheetManager} from 'styled-components';
import createCache from '@emotion/cache';
import {CacheProvider} from '@emotion/react';

/**
 * Web component wrapper that wrap the react component into a shadow dom web component
 * shadow dom is used to isolate your custom component from element styles
 */

export function WebComponentWrapper(
  NAME: string,
  Component: (args: any) => JSX.Element,
  CustomProviders: (props: any) => React.ReactElement
): void {
  class WebComponent extends HTMLElement {
    props = {};

    connectedCallback() {
      const shadowRoot = super.attachShadow({mode: 'open'});
      const mountPoint = document.createElement('span');
      const emotionRoot = document.createElement('style');
      const stylesheet = document.createElement('div');
      mountPoint.id = NAME;
      shadowRoot.appendChild(mountPoint);
      shadowRoot.appendChild(emotionRoot);
      shadowRoot.appendChild(stylesheet);



      const cache = createCache({
        key: `css`,
        prepend: true,
        // speedy:false, default true when false css rendered in dom
        container: emotionRoot,
      });
      if ((Component as any).propTypes) {
        this.props = Object.keys((Component as any).propTypes).concat('loginMode').reduce((obj, item) => {
          return {
            ...obj,
            [`${item}`]: super.getAttribute(item),
          };
        }, {});
      }

      ReactDOM.render(
        <React.StrictMode>
          <StyleSheetManager disableVendorPrefixes={false} disableCSSOMInjection={true} target={stylesheet}>
            <CustomProviders {...this.props} >
              <CacheProvider value={cache}>
                <Component {...this.props} />
              </CacheProvider>
            </CustomProviders>
          </StyleSheetManager>
        </React.StrictMode>,
        mountPoint
      );
    }
  }

  if (!customElements.get(NAME)) {
    customElements.define(NAME, WebComponent as any);
  }
}
